export default "__VITE_ASSET__CSSkTJtp__"